/* ProductInfoComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ProductInfoRenderer");

class ProductInfoComponent extends EventEmitter {
    constructor(UserSession, SystemDetails) {
        super();
        this._userSession = UserSession;
        this._SystemDetails = SystemDetails;
        this._activeOrgId = undefined;
        this._systemData = undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {

    }

    _unregisterListeners() {

    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown()
            .then(() => {
                this._renderer = undefined;
                this._userSession = undefined;
                this._SystemDetails = undefined;
                this._activeOrgId = undefined;
                this._systemData = undefined;
            }, (err) => {
                console.log("Error shutting down.", err);
            });
        return prom;
    }

    whenModelIsReady() {
        this._activeOrgId = this._userSession.activeOrganization.id;
        return this._SystemDetails.loadDetails(this._activeOrgId).then(data => {
            this._systemData = data;
            return Promise.resolve(data);
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    organizationChanged({ id }) {
        if (this._activeOrgId === id) {
            return;
        }
        this._activeOrgId = id;
        this.emit("OrganizationChanged");
    }
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ProductInfoComponent;

ProductInfoComponent.$groupName = "Global";
ProductInfoComponent.$license = ["GLUWARE"];

ProductInfoComponent.$displayName = "Product Information";

ProductInfoComponent.$inject = [
    "$teve.userSession",
    "$teve.entities.SystemDetails"
];
